import React from 'react'
import { useGLTF } from '@react-three/drei'

export default function PuckModel(props) {
  const { nodes } = useGLTF('/puck_model.glb')
  const {color = 0x030303} = props;
  return (
    <mesh castShadow geometry={nodes.Cylinder.geometry} >
      <meshPhongMaterial color={color} specular={0x222222} />
    </mesh>
  )
}

useGLTF.preload('/puck_model.glb')
